import axios from 'axios'

import config from '@/config/env'

export default {
	headers : {
    // 'crossDomain': true,
		'X-Parse-Application-Id' : config.api.appId
    // 'Access-Control-Allow-Origin' : '*'
	},
	getHeaders () {

		return this.headers

	},
	setHeader (data) {

		this.headers[data.key] = data.value

	},
	deleteHeader (data) {

		delete this.headers[data.key]

	},
	request () {

		let headers = this.headers

		return axios
			.create({
				headers : headers,
				timeout : 5000 * 60 * 100
			})

	}
}



// WEBPACK FOOTER //
// ./src/components/general/http/http.js